// v2/components/SearchNotice.js — yazim duzeltmesi / benzer kod bildirimi
import React from 'react';
import { Info, X } from 'lucide-react';
import styles from './SearchNotice.module.css';

export default function SearchNotice({ info, current, onClear }) {
  if (!info || !info.fuzzy || !info.aranan) return null;
  // Kullanici yeni bir sey yaziyorsa eski bildirimi gosterme
  if (current !== undefined && String(current).trim() !== info.aranan) return null;

  return (
    <div className={styles.notice} role="status">
      <Info size={16} className={styles.icon} />
      <span className={styles.text}>
        <b>“{info.aranan}”</b> için tam eşleşme bulunamadı.{' '}
        {info.corrected
          ? <>Bunun yerine <b>“{info.corrected}”</b> sonuçları gösteriliyor.</>
          : <>Benzer ürün kodları gösteriliyor.</>}
      </span>
      {onClear && (
        <button type="button" className={styles.clear} onClick={onClear}>
          <X size={13} /> Aramayı temizle
        </button>
      )}
    </div>
  );
}
